import HTML from '../Assets/Images/skills/html.png';
import CSS from '../Assets/Images/skills/css.png';
import SCSS from '../Assets/Images/skills/scss.png';
import JS from '../Assets/Images/skills/js.png';
import TS from '../Assets/Images/skills/ts.png';
import React from '../Assets/Images/skills/react.png';
import ReactNative from '../Assets/Images/skills/react-native.png';
import Redux from '../Assets/Images/skills/redux.png';
import Zustand from '../Assets/Images/skills/zustand.png';
import Tailwind from '../Assets/Images/skills/tailwind.png';
import NativeWind from '../Assets/Images/skills/native-wind.png';
import Git from '../Assets/Images/skills/git.png';
import GitHub from '../Assets/Images/skills/github.png';
import Firebase from '../Assets/Images/skills/firebase.png';
import Supabase from '../Assets/Images/skills/supabase.png';
import Figma from '../Assets/Images/skills/figma.png';
import Expo from '../Assets/Images/skills/expo.png';

export const SKILLS = {
	languages: [
		{name: 'JavaScript', img: JS},
		{name: 'TypeScript', img: TS},
		{name: 'HTML', img: HTML},
		{name: 'CSS', img: CSS},
		{name: 'SCSS', img: SCSS},
	],
	libraries: [
		{name: 'React', img: React},
		{name: 'React Native', img: ReactNative},
		{name: 'Redux', img: Redux},
		{name: 'Zustand', img: Zustand},
		{name: 'Tailwind CSS', img: Tailwind},
		{name: 'NativeWind', img: NativeWind},
	],
	tools: [
		{name: 'Firebase', img: Firebase},
		{name: 'Supabase', img: Supabase},
		{name: 'Git', img: Git},
		{name: 'GitHub', img: GitHub},
		{name: 'Figma', img: Figma},
		{name: 'Expo', img: Expo},
	],
};
